/* ==========================================================================
   My Pro Padel Shop — Sélecteur & comparateur de raquettes (natif, vanilla JS)
   Port fidèle de l'app Lovable "Padel Matchmaker" : même algorithme de score,
   même radar, mêmes 5 questions. Les données produits (prix, stock, image,
   URL) et les caractéristiques techniques (metafields padel.*) viennent de
   Shopify et sont injectées côté serveur par le template Liquid — aucun
   appel réseau, aucune dépendance externe.
   ========================================================================== */
(function () {
  "use strict";

  var ROOT_ID = "mpps-raquettes-app";
  var DATA_ID = "mpps-raquettes-data";
  var WHATSAPP_NUMBER = "33676418661";

  var RADAR_AXES = [
    { key: "power", label: "Puissance" },
    { key: "control", label: "Contrôle" },
    { key: "maneuverability", label: "Maniabilité" },
    { key: "tolerance", label: "Tolérance" },
    { key: "comfort", label: "Confort" },
    { key: "ballOutput", label: "Sortie de balle" }
  ];

  var LEVEL_ORDER = ["debutant", "intermediaire", "avance", "expert"];
  var LEVEL_LABEL = { debutant: "débutant", intermediaire: "intermédiaire", avance: "avancé", expert: "expert" };
  var LEVEL_FRENCH = { debutant: "Débutant", intermediaire: "Intermédiaire", avance: "Avancé", expert: "Expert" };
  var SERIES_COLORS = ["oklch(0.278 0.062 254)", "oklch(0.63 0.115 176)", "oklch(0.62 0.13 45)", "oklch(0.55 0.12 320)"];
  var POSITION_LABELS = ["", "EXCELLENTE ALTERNATIVE", "AUTRE OPTION ADAPTÉE", "AUTRE OPTION ADAPTÉE"];

  /* ------------------------------ Icônes ----------------------------- */
  /* Mini-set de pictogrammes trait (style lucide), inline SVG — pas de police d'icônes externe. */

  var ICON_PATHS = {
    target: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>',
    barChart: '<line x1="4" y1="20" x2="4" y2="12"></line><line x1="12" y1="20" x2="12" y2="8"></line><line x1="20" y1="20" x2="20" y2="4"></line><line x1="2" y1="20" x2="22" y2="20"></line>',
    arrowRight: '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>',
    arrowLeft: '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
    crosshair: '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>',
    scale: '<line x1="12" y1="3" x2="12" y2="21"></line><path d="M5 7l-3 7a3.5 3.5 0 0 0 6 0l-3-7z"></path><path d="M19 7l-3 7a3.5 3.5 0 0 0 6 0l-3-7z"></path><path d="M5 7h14"></path>',
    zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
    check: '<polyline points="20 6 9 17 4 12"></polyline>',
    info: '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
    sparkles: '<path d="M12 3l1.6 4.8L18.4 9.4 13.6 11l-1.6 4.8L10.4 11 5.6 9.4 10.4 7.8 12 3z"></path><path d="M19 15l.7 2.1 2.1.7-2.1.7-.7 2.1-.7-2.1-2.1-.7 2.1-.7.7-2.1z"></path>',
    externalLink: '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
    messageCircle: '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>',
    search: '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>',
    plus: '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>',
    x: '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>'
  };

  function icon(name, size, extraStyle) {
    size = size || 16;
    var inner = ICON_PATHS[name] || "";
    return '<span class="mpps-icon" style="width:' + size + 'px;height:' + size + 'px;' + (extraStyle || "") + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + inner + "</svg></span>";
  }

  /* ---------------------------- Utils ---------------------------- */

  function esc(str) {
    return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function formatPrice(value) {
    try {
      return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value);
    } catch (e) {
      return Math.round(value) + " €";
    }
  }

  function qs(search) {
    var out = {};
    (search || "").replace(/^[?#]/, "").split("&").forEach(function (pair) {
      if (!pair) return;
      var idx = pair.indexOf("=");
      var k = decodeURIComponent(idx === -1 ? pair : pair.slice(0, idx));
      var v = decodeURIComponent(idx === -1 ? "" : pair.slice(idx + 1));
      out[k] = v;
    });
    return out;
  }

  function toQuery(obj) {
    return Object.keys(obj)
      .filter(function (k) { return obj[k] !== undefined && obj[k] !== null && obj[k] !== ""; })
      .map(function (k) { return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]); })
      .join("&");
  }

  function levelListLabel(levels) {
    return (levels || []).map(function (l) { return LEVEL_LABEL[l] || l; }).join(" / ");
  }

  /* ------------------------- Catalogue ---------------------------- */

  function normLevels(frenchArr) {
    var out = [];
    (frenchArr || []).forEach(function (fr) {
      Object.keys(LEVEL_FRENCH).forEach(function (code) {
        if (LEVEL_FRENCH[code].toLowerCase() === String(fr).toLowerCase()) out.push(code);
      });
    });
    return out;
  }

  function buildCatalog(raw) {
    return (raw || []).map(function (p) {
      var fields = {
        power: p.puissance, control: p.controle, maneuverability: p.maniabilite,
        tolerance: p.tolerance, comfort: p.confort, ballOutput: p.sortie_balle
      };
      var missing = [];
      Object.keys(fields).forEach(function (k) {
        if (fields[k] === null || fields[k] === undefined) missing.push(k);
      });
      var level = normLevels(p.niveau);
      if (level.length === 0) missing.push("niveau");

      return {
        id: p.handle,
        handle: p.handle,
        brand: p.brand || "",
        title: p.title || "",
        image: p.image || "",
        price: Number(p.price) || 0,
        compareAtPrice: p.compareAtPrice ? Number(p.compareAtPrice) : null,
        available: !!p.available,
        url: p.url || "",
        level: level,
        shape: p.forme || "",
        balance: p.equilibre || "",
        weight: p.poids ? p.poids + " g" : "",
        power: fields.power || 0,
        control: fields.control || 0,
        maneuverability: fields.maneuverability || 0,
        tolerance: fields.tolerance || 0,
        comfort: fields.comfort || 0,
        ballOutput: fields.ballOutput || 0,
        incomplete: missing.length > 0
      };
    });
  }

  function availableRackets(all) { return all.filter(function (r) { return r.available; }); }
  function scorableRackets(all) { return availableRackets(all).filter(function (r) { return !r.incomplete; }); }
  function racketsByIds(all, ids) {
    return ids.map(function (id) {
      for (var i = 0; i < all.length; i++) if (all[i].id === id) return all[i];
      return null;
    }).filter(Boolean);
  }

  /* --------------------------- Scoring ----------------------------- */
  /* Port fidèle 1:1 de src/lib/scoring.ts (app Lovable) */

  function styleValue(r, style) {
    if (style === "controle") return r.control * 0.5 + r.maneuverability * 0.35 + r.tolerance * 0.15;
    if (style === "puissance") return r.power * 0.6 + r.ballOutput * 0.4;
    var balanceBonus = 10 - Math.abs(r.power - r.control) * 1.2;
    var base = (r.power + r.control + r.maneuverability) / 3;
    return base * 0.55 + Math.max(0, balanceBonus) * 0.45;
  }

  function comfortValue(r, comfort) {
    if (comfort === "none") return 6;
    if (comfort === "confort") return r.comfort;
    return (r.comfort * 2 + r.tolerance) / 3;
  }

  function budgetPenalty(price, budget) {
    if (budget === null || price <= budget) return 0;
    var over = price - budget;
    var ratio = over / budget;
    if (ratio <= 0.1) return 8;
    if (ratio <= 0.25) return 22;
    return 50;
  }

  function levelScore(r, level) {
    if (r.level.indexOf(level) !== -1) return 10;
    var wanted = LEVEL_ORDER.indexOf(level);
    if (!r.level.length) return 0;
    var distance = Math.min.apply(null, r.level.map(function (l) { return Math.abs(LEVEL_ORDER.indexOf(l) - wanted); }));
    return Math.max(0, 10 - distance * 4);
  }

  function calculateRacketMatch(profile, r) {
    var style = styleValue(r, profile.style);
    var raw = style * 5.5 + levelScore(r, profile.level) * 2.5 + comfortValue(r, profile.comfort) * 2;
    var score = raw - budgetPenalty(r.price, profile.budget);
    return Math.max(30, Math.min(99, Math.round(score)));
  }

  function buildHighlights(profile, r) {
    var out = [];
    if (profile.style === "controle") {
      if (r.control >= 7.5) out.push("Très bon contrôle");
      if (r.maneuverability >= 7.5) out.push("Facile à manier");
      if (r.tolerance >= 7.5) out.push("Grande tolérance");
    } else if (profile.style === "puissance") {
      if (r.power >= 8) out.push("Puissance élevée");
      if (r.ballOutput >= 7.5) out.push("Excellente sortie de balle");
    } else {
      if (Math.abs(r.power - r.control) <= 1.5) out.push("Excellent compromis contrôle/puissance");
      if (r.maneuverability >= 7) out.push("Bonne maniabilité");
    }
    if (r.level.indexOf(profile.level) !== -1) out.push("Niveau parfaitement adapté");
    if (profile.comfort !== "none" && r.comfort >= 7.5) out.push("Confort à l'impact");

    if (out.length < 2) {
      var axes = [
        { key: "power", label: "Puissance" }, { key: "control", label: "Contrôle" },
        { key: "maneuverability", label: "Maniabilité" }, { key: "tolerance", label: "Tolérance" },
        { key: "comfort", label: "Confort" }, { key: "ballOutput", label: "Sortie de balle" }
      ].slice().sort(function (a, b) { return r[b.key] - r[a.key]; });
      for (var i = 0; i < axes.length && out.length < 2; i++) {
        if (out.indexOf(axes[i].label) === -1) out.push(axes[i].label);
      }
    }
    return out.slice(0, 3);
  }

  function buildExplanation(profile, r, budgetDelta) {
    var parts = [];
    if (profile.style === "controle") {
      parts.push("Elle privilégie la précision et reste facile à manier, ce qui correspond au jeu que vous recherchez.");
    } else if (profile.style === "puissance") {
      parts.push("Elle offre l'impact et la sortie de balle que vous recherchez en attaque.");
    } else {
      parts.push("Son équilibre entre contrôle et puissance en fait une raquette très polyvalente.");
    }
    if (profile.comfort === "coude" || profile.comfort === "epaule") {
      parts.push("Son niveau de confort et de tolérance en fait une option cohérente avec la sensation de souplesse que vous recherchez.");
    } else if (profile.comfort === "confort") {
      parts.push("Son confort à l'impact reste l'un de ses points forts.");
    }
    if (r.level.indexOf(profile.level) !== -1) {
      parts.push("Son profil est adapté à un joueur de niveau " + (LEVEL_LABEL[profile.level] || profile.level) + ".");
    }
    if (budgetDelta > 0) {
      parts.push("Légèrement au-dessus de votre budget, mais particulièrement adaptée à votre profil.");
    }
    return parts.slice(0, 3).join(" ");
  }

  function getRecommendations(profile, catalog, limit) {
    limit = limit || 4;
    var pool = scorableRackets(catalog);
    if (pool.length < 2) {
      /* Garde-fou : si moins de 2 raquettes ont une fiche technique complète,
         on élargit au stock disponible (caractéristiques manquantes traitées
         comme neutres) plutôt que de laisser le visiteur sans recommandation. */
      pool = availableRackets(catalog);
    }
    var scored = pool.map(function (r) {
      var budgetDelta = profile.budget !== null && r.price > profile.budget ? r.price - profile.budget : 0;
      return { racket: r, score: calculateRacketMatch(profile, r), budgetDelta: budgetDelta, highlights: buildHighlights(profile, r) };
    }).sort(function (a, b) { return b.score - a.score; });

    var top = scored.slice(0, 3);
    var fourth = scored[3];
    if (limit >= 4 && fourth && top[2] && top[2].score - fourth.score <= 3) top.push(fourth);

    return top.map(function (m, i) {
      return {
        racket: m.racket, score: m.score, budgetDelta: m.budgetDelta, highlights: m.highlights,
        explanation: buildExplanation(profile, m.racket, m.budgetDelta),
        label: i === 0 ? null : (POSITION_LABELS[i] || "AUTRE OPTION ADAPTÉE")
      };
    });
  }

  /* --------------------------- Radar SVG --------------------------- */

  function radarPoint(i, value, radius, center, len) {
    var angle = (Math.PI * 2 * i) / len - Math.PI / 2;
    var r = (value / 10) * radius;
    return [center + r * Math.cos(angle), center + r * Math.sin(angle)];
  }

  function radarSVG(series, size) {
    size = size || 300;
    var center = size / 2, radius = size / 2 - 12, len = RADAR_AXES.length;
    var levels = [2.5, 5, 7.5, 10];
    var svg = '<svg viewBox="-92 -26 ' + (size + 184) + ' ' + (size + 52) + '" class="mpps-radar-svg" role="img" aria-label="Radar des caractéristiques">';

    levels.forEach(function (lvl) {
      var pts = RADAR_AXES.map(function (_, i) { return radarPoint(i, lvl, radius, center, len).join(","); }).join(" ");
      svg += '<polygon points="' + pts + '" fill="none" stroke="#dfe3ee" stroke-width="1"></polygon>';
    });
    RADAR_AXES.forEach(function (_, i) {
      var p = radarPoint(i, 10, radius, center, len);
      svg += '<line x1="' + center + '" y1="' + center + '" x2="' + p[0] + '" y2="' + p[1] + '" stroke="#dfe3ee" stroke-width="1"></line>';
    });
    series.forEach(function (s) {
      var pts = s.values.map(function (v, i) { return radarPoint(i, v, radius, center, len).join(","); }).join(" ");
      svg += '<polygon points="' + pts + '" fill="' + s.color + '" fill-opacity="' + (series.length > 1 ? 0.14 : 0.18) + '" stroke="' + s.color + '" stroke-width="2" stroke-linejoin="round"></polygon>';
    });
    RADAR_AXES.forEach(function (axis, i) {
      var p = radarPoint(i, 11.25, radius, center, len);
      var anchor = Math.abs(p[0] - center) < 4 ? "middle" : (p[0] > center ? "start" : "end");
      svg += '<text x="' + p[0] + '" y="' + p[1] + '" text-anchor="' + anchor + '" dominant-baseline="middle" class="mpps-radar-label">' + esc(axis.label) + "</text>";
    });
    svg += "</svg>";

    if (series.length > 1) {
      svg += '<ul class="mpps-radar-legend">' + series.map(function (s) {
        return '<li><span class="mpps-dot" style="background:' + s.color + '"></span>' + esc(s.name) + "</li>";
      }).join("") + "</ul>";
    }
    return svg;
  }

  function racketSeries(r, color) {
    return [{ name: r.title, color: color, values: RADAR_AXES.map(function (a) { return r[a.key]; }) }];
  }

  /* -------------------------- WhatsApp CTA -------------------------- */

  function buildWhatsappUrl(titles) {
    var msg = "Bonjour, je cherche conseil pour choisir ma raquette de padel sur My Pro Padel Shop.";
    if (titles && titles.length) {
      msg += " Le comparateur du site m'a orienté vers : " + titles.join(", ") + ". Pouvez-vous me confirmer le meilleur choix ?";
    }
    return "https://wa.me/" + WHATSAPP_NUMBER + "?text=" + encodeURIComponent(msg);
  }

  /* ----------------------------- App -------------------------------- */

  function App(root, catalog) {
    this.root = root;
    this.catalog = catalog;
    this.boot();
  }

  App.prototype.boot = function () {
    var self = this;
    window.addEventListener("hashchange", function () { self.route(); });
    this.route();
  };

  App.prototype.navigate = function (hash) { window.location.hash = hash; };

  App.prototype.route = function () {
    var hash = window.location.hash || "#/";
    var parts = hash.replace(/^#/, "").split("?");
    var path = parts[0] || "/";
    var search = qs(parts[1]);
    window.scrollTo(0, 0);

    if (path === "/selecteur") return this.renderSelecteur();
    if (path === "/resultats") return this.renderResultats(search);
    if (path === "/comparateur") return this.renderComparateur(search);
    return this.renderHome();
  };

  App.prototype.renderHome = function () {
    this.root.innerHTML =
      '<div class="mpps-home-head">' +
        '<h1>Trouvez la raquette<br>qui vous correspond <em>vraiment</em></h1>' +
        '<p>Notre outil vous aide à choisir selon votre niveau, votre jeu, vos sensations, votre confort et votre budget.</p>' +
        '<span class="mpps-pill">5 questions · Quelques secondes · Des recommandations personnalisées</span>' +
      '</div>' +
      '<div class="mpps-home-grid">' +
        '<a href="#/selecteur" class="mpps-card mpps-home-tile mpps-home-tile-primary">' +
          '<span class="mpps-home-tile-icon">' + icon("target", 20) + '</span>' +
          '<div><h2>Trouver ma raquette</h2><p>Répondez à 5 questions et découvrez les modèles les plus adaptés à votre jeu.</p></div>' +
          '<span class="mpps-btn mpps-btn-block" style="background:#fff;color:var(--mpps-navy);">Commencer ' + icon("arrowRight", 15) + '</span>' +
        '</a>' +
        '<a href="#/comparateur" class="mpps-card mpps-home-tile mpps-home-tile-secondary">' +
          '<span class="mpps-home-tile-icon">' + icon("barChart", 20) + '</span>' +
          '<div><h2>Comparer des raquettes</h2><p>Vous avez déjà quelques modèles en tête ? Comparez jusqu\'à 4 raquettes côte à côte.</p></div>' +
          '<span class="mpps-btn mpps-btn-outline mpps-btn-block">Comparer ' + icon("arrowRight", 15) + '</span>' +
        '</a>' +
      '</div>';
  };

  var QUIZ_STEPS = [
    {
      key: "level", question: "Quel est votre niveau ?",
      options: [
        { value: "debutant", label: "Débutant", hint: "Je découvre le padel" },
        { value: "intermediaire", label: "Intermédiaire", hint: "Je joue régulièrement" },
        { value: "avance", label: "Avancé", hint: "Je maîtrise les trajectoires" },
        { value: "expert", label: "Expert", hint: "Je joue en compétition" }
      ]
    },
    {
      key: "side", question: "De quel côté jouez-vous principalement ?",
      help: "Votre côté de jeu nous aide à mieux comprendre votre profil et vos besoins. C'est un indicateur, jamais une règle absolue.",
      options: [
        { value: "droite", label: "Droite" }, { value: "gauche", label: "Gauche" },
        { value: "les-deux", label: "Les deux" }, { value: "je-ne-sais-pas", label: "Je débute / Je ne sais pas encore" }
      ]
    },
    {
      key: "style", question: "Quel type de jeu vous correspond le mieux ?",
      subtitle: "Choisissez ce qui compte le plus pour vous sur le terrain.", large: true,
      options: [
        { value: "controle", label: "Contrôle & maniabilité", hint: "Je privilégie la précision et une raquette facile à manier.", icon: "crosshair" },
        { value: "polyvalence", label: "Polyvalence", hint: "Je cherche un bon équilibre entre contrôle et puissance.", icon: "scale" },
        { value: "puissance", label: "Puissance", hint: "Je veux plus d'impact et d'efficacité dans mes attaques.", icon: "zap" }
      ]
    },
    {
      key: "comfort", question: "Le confort est-il un critère important pour vous ?",
      help: "Ces informations servent uniquement à privilégier des caractéristiques de confort et de tolérance. Cet outil n'a aucune vocation médicale.",
      options: [
        { value: "none", label: "Pas particulièrement" },
        { value: "confort", label: "Oui, je privilégie une raquette confortable" },
        { value: "coude", label: "J'ai le coude sensible" },
        { value: "epaule", label: "J'ai l'épaule sensible" }
      ]
    },
    {
      key: "budget", question: "Quel budget souhaitez-vous consacrer à votre raquette ?",
      help: "Le budget influence le classement, sans exclure une raquette particulièrement adaptée.",
      options: [
        { value: "150", label: "Moins de 150 €" }, { value: "220", label: "150 € – 220 €" },
        { value: "300", label: "220 € – 300 €" }, { value: "none", label: "300 € et +" }
      ]
    }
  ];

  App.prototype.renderSelecteur = function (stepIndex, answers) {
    stepIndex = stepIndex || 0;
    answers = answers || {};
    var self = this;
    var step = QUIZ_STEPS[stepIndex];
    var progress = ((stepIndex + 1) / QUIZ_STEPS.length) * 100;
    var selected = answers[step.key];

    var html = '<div class="mpps-quiz-top">';
    if (stepIndex === 0) {
      html += '<a href="#/" class="mpps-back-link">' + icon("arrowLeft", 15) + ' Accueil</a>';
    } else {
      html += '<button type="button" class="mpps-back-link" data-action="quiz-back">' + icon("arrowLeft", 15) + ' Retour</button>';
    }
    html += '<span class="mpps-quiz-step-count">' + (stepIndex + 1) + " / " + QUIZ_STEPS.length + "</span></div>";
    html += '<div class="mpps-progress"><div class="mpps-progress-bar" style="width:' + progress + '%"></div></div>';
    html += '<div class="mpps-quiz-question"><h1>' + esc(step.question) + "</h1>";
    if (step.subtitle) html += '<p class="mpps-quiz-subtitle">' + esc(step.subtitle) + "</p>";
    if (step.help) html += '<p class="mpps-quiz-help"><span>' + icon("info", 16, "margin-top:2px;") + '</span><span>' + esc(step.help) + "</span></p>";

    html += '<div class="mpps-options' + (step.large ? "" : " mpps-options-2col") + '">';
    step.options.forEach(function (opt) {
      var active = selected === opt.value;
      html += '<button type="button" class="mpps-option' + (step.large ? " mpps-option-large" : "") + (active ? " mpps-option-selected" : "") + '" data-value="' + esc(opt.value) + '">';
      if (step.large) {
        html += '<span class="mpps-option-icon">' + icon(opt.icon || "sparkles", 19) + "</span>";
      }
      html += '<span style="flex:1;min-width:0;"><span class="mpps-option-label">' + esc(opt.label) + "</span>";
      if (opt.hint) html += '<span class="mpps-option-hint">' + esc(opt.hint) + "</span>";
      html += "</span>";
      if (active) html += '<span class="mpps-option-check">' + icon("check", 18) + "</span>";
      html += "</button>";
    });
    html += "</div></div>";

    this.root.innerHTML = html;

    this.root.querySelectorAll('[data-action="quiz-back"]').forEach(function (btn) {
      btn.addEventListener("click", function () { self.renderSelecteur(stepIndex - 1, answers); });
    });
    this.root.querySelectorAll(".mpps-option").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = Object.assign({}, answers);
        next[step.key] = btn.getAttribute("data-value");
        if (stepIndex === QUIZ_STEPS.length - 1) {
          self.navigate("#/resultats?" + toQuery(next));
        } else {
          self.renderSelecteur(stepIndex + 1, next);
        }
      });
    });
  };

  function toProfile(search) {
    if (!search.level || !search.style || !search.comfort) return null;
    var budget = search.budget && search.budget !== "none" ? Number(search.budget) : null;
    return { level: search.level, side: search.side || "", style: search.style, comfort: search.comfort, budget: budget };
  }

  App.prototype.renderResultats = function (search) {
    var self = this;
    var profile = toProfile(search);

    if (!profile) {
      this.root.innerHTML =
        '<div class="mpps-empty-state"><h1>Profil incomplet</h1><p>Reprenez le questionnaire pour obtenir vos recommandations.</p>' +
        '<a href="#/selecteur" class="mpps-btn mpps-btn-primary">Recommencer</a></div>';
      return;
    }

    var results = getRecommendations(profile, this.catalog, 4);
    var best = results[0];
    var others = results.slice(1);

    if (!best) {
      this.root.innerHTML =
        '<div class="mpps-empty-state"><h1>Pas encore de recommandation fiable</h1>' +
        "<p>Nous n'avons pas encore assez de modèles compatibles avec votre profil pour vous proposer une recommandation fiable. " +
        "Plutôt que de vous proposer des données inventées, nous préférons vous mettre directement en relation avec Flo.</p></div>" +
        this.whatsappBlockHtml([]);
      this.bindWhatsapp();
      return;
    }

    var compareIds = results.map(function (r) { return r.racket.id; }).join(",");

    var html = '<div class="mpps-results-intro">' +
      '<a href="#/selecteur" class="mpps-back-link">' + icon("arrowLeft", 15) + ' Modifier mes réponses</a>' +
      "<h1>Nous avons trouvé les raquettes qui correspondent le mieux à votre profil.</h1>" +
      "<p>" + results.length + " modèles disponibles, classés selon votre niveau, votre type de jeu, votre confort et votre budget.</p>" +
      "</div>";

    html += this.bestCardHtml(best);

    if (others.length) {
      html += '<h2 class="mpps-secondary-title">Autres recommandations adaptées</h2><div class="mpps-secondary-grid">';
      others.forEach(function (m) { html += self.secondaryCardHtml(m); });
      html += "</div>";
    }

    html += this.whatsappBlockHtml(results.map(function (r) { return r.racket.title; }));
    html += '<a href="#/comparateur?ids=' + encodeURIComponent(compareIds) + '" class="mpps-btn mpps-btn-primary mpps-compare-cta">' + icon("barChart", 18) + ' Comparer ces raquettes</a>';

    this.root.innerHTML = html;
    this.root.querySelector(".mpps-best-media .mpps-radar-wrap").innerHTML = radarSVG(racketSeries(best.racket, "oklch(0.278 0.062 254)"), 300);
    this.bindWhatsapp();
  };

  App.prototype.bestCardHtml = function (match) {
    var r = match.racket;
    var html = '<article class="mpps-card mpps-best-card">' +
      '<div class="mpps-best-head">' + icon("sparkles", 15) + '<span class="mpps-eyebrow">Notre choix</span><span class="mpps-best-badge">' + match.score + " % compatible</span></div>" +
      '<div class="mpps-best-body">' +
      '<div class="mpps-best-media">' + (r.image ? '<img src="' + esc(r.image) + '" alt="Raquette ' + esc(r.title) + '">' : "") + '<div class="mpps-radar-wrap"></div></div>' +
      '<div class="mpps-best-model">' +
      '<p class="mpps-eyebrow">' + esc(r.brand) + "</p><h2>" + esc(r.title) + "</h2>" +
      '<div class="mpps-price-row"><span class="mpps-price">' + formatPrice(r.price) + "</span>";
    if (r.compareAtPrice) html += '<span class="mpps-price-compare">' + formatPrice(r.compareAtPrice) + "</span>";
    html += '<span class="mpps-availability"><span class="mpps-dot-status' + (r.available ? " mpps-in-stock" : "") + '"></span>' + (r.available ? "En stock" : "Indisponible") + "</span></div>";

    html += '<ul class="mpps-highlights">' + match.highlights.map(function (h) { return '<li class="mpps-pill">' + esc(h) + "</li>"; }).join("") + "</ul>";

    html += '<dl class="mpps-spec-grid">' +
      "<div><dt>Forme</dt><dd>" + esc(r.shape) + "</dd></div>" +
      "<div><dt>Équilibre</dt><dd>" + esc(r.balance) + "</dd></div>" +
      "<div><dt>Poids</dt><dd>" + esc(r.weight) + "</dd></div>" +
      "<div><dt>Niveau conseillé</dt><dd>" + esc(levelListLabel(r.level)) + "</dd></div></dl>";

    html += '<div class="mpps-why-box"><h3>Pourquoi elle vous correspond</h3><p>' + esc(match.explanation) + "</p></div>";

    if (match.budgetDelta > 0) {
      html += '<div class="mpps-budget-note"><span class="mpps-eyebrow">Ça vaut le détour</span><p>+' + Math.round(match.budgetDelta) + " € par rapport à votre budget</p>" +
        '<p class="mpps-muted">Légèrement au-dessus de votre budget, mais particulièrement adaptée à votre profil.</p></div>';
    }

    html += this.productCtaHtml(r, true);
    html += "</div></div></article>";
    return html;
  };

  App.prototype.secondaryCardHtml = function (match) {
    var r = match.racket;
    var html = '<article class="mpps-card mpps-secondary-card">';
    if (match.label) html += '<span class="mpps-label-tag">' + esc(match.label) + "</span>";
    if (r.image) html += '<img src="' + esc(r.image) + '" alt="Raquette ' + esc(r.title) + '" loading="lazy">';
    html += '<p class="mpps-eyebrow">' + esc(r.brand) + "</p><h3>" + esc(r.title) + '</h3><p class="mpps-sec-highlights">' + esc(match.highlights.join(" • ")) + "</p>";
    html += '<div class="mpps-sec-footer"><span class="mpps-price">' + formatPrice(r.price) + '</span><span class="mpps-score-chip">' + match.score + " %</span></div>";
    html += '<div style="margin-top:6px;"><span class="mpps-availability"><span class="mpps-dot-status' + (r.available ? " mpps-in-stock" : "") + '"></span>' + (r.available ? "En stock" : "Indisponible") + "</span></div>";
    if (match.budgetDelta > 0) html += '<div class="mpps-budget-note"><span class="mpps-eyebrow">Ça vaut le détour</span><p>+' + Math.round(match.budgetDelta) + " €</p></div>";
    html += this.productCtaHtml(r, false);
    html += "</article>";
    return html;
  };

  App.prototype.productCtaHtml = function (r, primary) {
    var cls = "mpps-btn " + (primary ? "mpps-btn-primary mpps-btn-block" : "mpps-btn-outline mpps-btn-block") + '" style="margin-top:' + (primary ? "20px" : "12px") + ";font-size:" + (primary ? "13px" : "11px") + '"';
    if (!r.url) {
      return '<p class="mpps-btn mpps-btn-disabled mpps-btn-block" style="margin-top:' + (primary ? "20px" : "12px") + ';">Fiche produit bientôt disponible</p>';
    }
    return '<a href="' + esc(r.url) + '" class="' + cls + ">Voir cette raquette " + icon("externalLink", 15) + "</a>";
  };

  App.prototype.whatsappBlockHtml = function (titles) {
    return '<section class="mpps-card mpps-whatsapp-block">' +
      "<h2>Encore un doute sur votre raquette ?</h2>" +
      "<p>Flo de My Pro Padel Shop peut vous conseiller personnellement selon votre niveau et votre façon de jouer.</p>" +
      '<a href="' + buildWhatsappUrl(titles) + '" target="_blank" rel="noreferrer" class="mpps-btn mpps-btn-whatsapp">' + icon("messageCircle", 18) + ' Demander conseil à Flo sur WhatsApp</a></section>';
  };

  App.prototype.bindWhatsapp = function () {};

  App.prototype.renderComparateur = function (search) {
    var self = this;
    var ids = (search.ids || "").split(",").filter(Boolean);
    var selected = racketsByIds(this.catalog, ids).slice(0, 4);
    var query = "";

    function renderList() {
      var html = '<div class="mpps-compare-intro"><h1>Comparer des raquettes</h1><p>Sélectionnez de 2 à 4 modèles pour les comparer côte à côte.</p></div>';

      html += '<div class="mpps-card mpps-search-card">' +
        '<div class="mpps-search-input-wrap">' + icon("search", 16) + '<input type="text" id="mpps-compare-search" placeholder="Rechercher une raquette..." value="' + esc(query) + '"' + (selected.length >= 4 ? " disabled" : "") + '></div>';
      if (selected.length >= 4) html += '<p class="mpps-search-hint">Maximum atteint : retirez un modèle pour en ajouter un autre.</p>';
      html += '<ul class="mpps-search-results" id="mpps-compare-search-results"></ul>';

      if (selected.length) {
        html += '<ul class="mpps-chips">' + selected.map(function (r, i) {
          return '<li class="mpps-chip"><span class="mpps-dot" style="background:' + SERIES_COLORS[i % 4] + '"></span>' + esc(r.title) +
            '<button type="button" class="mpps-chip-remove" data-remove="' + esc(r.id) + '" aria-label="Retirer">' + icon("x", 13) + "</button></li>";
        }).join("") + "</ul>";
      }
      html += "</div>";

      if (selected.length < 2) {
        html += '<p class="mpps-card mpps-compare-empty">Ajoutez au moins 2 raquettes pour lancer la comparaison.</p>';
      } else {
        var series = selected.map(function (r, i) { return { name: r.title, color: SERIES_COLORS[i % 4], values: RADAR_AXES.map(function (a) { return r[a.key]; }) }; });

        html += '<div class="mpps-card mpps-compare-radar-card"><h2>Radar comparatif</h2><div class="mpps-radar-wrap" id="mpps-compare-radar"></div></div>';

        html += '<div class="mpps-compare-products">' + selected.map(function (r) {
          var c = '<article class="mpps-card mpps-compare-product-card">' +
            (r.image ? '<img src="' + esc(r.image) + '" alt="Raquette ' + esc(r.title) + '" loading="lazy">' : "") +
            '<p class="mpps-eyebrow">' + esc(r.brand) + "</p><h3>" + esc(r.title) + "</h3>" +
            '<p class="mpps-price">' + formatPrice(r.price) + "</p>" +
            '<p class="mpps-avail-text">' + (r.available ? "En stock" : "Indisponible") + "</p>";
          c += r.url ? '<a href="' + esc(r.url) + '" class="mpps-btn mpps-btn-outline">Voir</a>' : '<p class="mpps-btn mpps-btn-disabled">Bientôt</p>';
          return c + "</article>";
        }).join("") + "</div>";

        html += '<div class="mpps-card mpps-compare-table">';
        RADAR_AXES.forEach(function (axis) {
          html += '<div class="mpps-compare-row"><p class="mpps-compare-row-label">' + esc(axis.label) + '</p><div class="mpps-compare-row-cells">' +
            selected.map(function (r, i) {
              return '<div><span class="mpps-compare-cell-name">' + esc(r.title) + '</span><span class="mpps-bar-cell"><span class="mpps-bar-track"><span class="mpps-bar-fill" style="width:' + (r[axis.key] * 10) + "%;background:" + SERIES_COLORS[i % 4] + ';"></span></span><span class="mpps-bar-value">' + r[axis.key] + "</span></span></div>";
            }).join("") + "</div></div>";
        });
        [["Niveau conseillé", function (r) { return esc(levelListLabel(r.level)); }],
         ["Forme", function (r) { return esc(r.shape); }],
         ["Équilibre", function (r) { return esc(r.balance); }],
         ["Poids", function (r) { return esc(r.weight); }],
         ["Prix", function (r) { return "<strong>" + formatPrice(r.price) + "</strong>"; }]
        ].forEach(function (row) {
          html += '<div class="mpps-compare-row"><p class="mpps-compare-row-label">' + row[0] + '</p><div class="mpps-compare-row-cells">' +
            selected.map(function (r) { return '<div><span class="mpps-compare-cell-name">' + esc(r.title) + "</span>" + row[1](r) + "</div>"; }).join("") + "</div></div>";
        });
        html += "</div>";
        html += '<p class="mpps-compare-footnote">Notes de 0 à 10, issues des fiches techniques My Pro Padel Shop.</p>';
      }

      self.root.innerHTML = html;

      if (selected.length >= 2) {
        self.root.querySelector("#mpps-compare-radar").innerHTML = radarSVG(
          selected.map(function (r, i) { return { name: r.title, color: SERIES_COLORS[i % 4], values: RADAR_AXES.map(function (a) { return r[a.key]; }) }; }), 320
        );
      }

      var input = self.root.querySelector("#mpps-compare-search");
      if (input) {
        input.addEventListener("input", function () { query = input.value; renderSearchResults(); });
        if (document.activeElement !== input && query) { /* keep focus logic simple */ }
      }
      self.root.querySelectorAll("[data-remove]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var id = btn.getAttribute("data-remove");
          var nextIds = selected.filter(function (r) { return r.id !== id; }).map(function (r) { return r.id; });
          self.navigate("#/comparateur?ids=" + encodeURIComponent(nextIds.join(",")));
        });
      });
      renderSearchResults();
    }

    function renderSearchResults() {
      var box = self.root.querySelector("#mpps-compare-search-results");
      if (!box) return;
      var q = query.trim().toLowerCase();
      if (!q) { box.innerHTML = ""; return; }
      var matches = self.catalog.filter(function (r) {
        return selected.indexOf(r) === -1 &&
          ((r.brand || "").toLowerCase().indexOf(q) !== -1 || (r.title || "").toLowerCase().indexOf(q) !== -1);
      }).slice(0, 6);
      box.innerHTML = matches.map(function (r) {
        return '<li><button type="button" class="mpps-search-result-btn" data-add="' + esc(r.id) + '">' +
          (r.image ? '<img src="' + esc(r.image) + '" alt="" loading="lazy">' : "") +
          '<span style="flex:1;min-width:0;"><span class="mpps-sr-title">' + esc(r.title) + '</span><span class="mpps-sr-meta">' + esc(r.brand) + " • " + formatPrice(r.price) + (r.available ? "" : " • indisponible") + "</span></span>" + icon("plus", 15) + "</button></li>";
      }).join("");
      box.querySelectorAll("[data-add]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (selected.length >= 4) return;
          var nextIds = selected.map(function (r) { return r.id; }).concat([btn.getAttribute("data-add")]);
          self.navigate("#/comparateur?ids=" + encodeURIComponent(nextIds.join(",")));
        });
      });
    }

    renderList();
  };

  /* ----------------------------- Init -------------------------------- */

  function init() {
    var root = document.getElementById(ROOT_ID);
    var dataEl = document.getElementById(DATA_ID);
    if (!root || !dataEl) return;
    var raw = [];
    try {
      raw = JSON.parse(dataEl.textContent || "[]");
    } catch (e) {
      raw = [];
      if (window.console && console.error) console.error("mpps-comparateur: échec de lecture des données produits", e);
    }
    var catalog = buildCatalog(raw);
    if (window.console && console.info) {
      console.info("mpps-comparateur: " + catalog.length + " raquette(s) chargée(s), " + availableRackets(catalog).length + " en stock, " + scorableRackets(catalog).length + " avec fiche complète.");
    }
    new App(root, catalog);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
